import { createContext, useContext, useEffect } from 'react';
const noop = () => {};
export const NavigationContext = createContext({ setUnsaved: noop, navigate: noop });
export function useUnsavedChanges(dirty) {
  const { setUnsaved } = useContext(NavigationContext);
  useEffect(() => { setUnsaved(dirty); return () => setUnsaved(false); }, [dirty, setUnsaved]);
}
